<template>
  <el-form
    ref="newPasswordForm"
    class="newPasswordForm"
    :model="form"
    :rules="rules"
    @submit.native.prevent="onSubmit"
  >
    <!-- PASSWORD & NEW PASSWORD -->
    <el-row
      :gutter="56"
      class="newPasswordForm__passwords"
    >
      <el-col
        :sm="12"
        :lg="6"
      >
        <el-form-item
          :label="$t('profile.newPasswordForm.passwordLabel')"
          prop="password"
        >
          <el-input
            v-model="form.password"
            show-password
            type="password"
            name="password"
            :placeholder="$t('profile.newPasswordForm.passwordPlaceholder')"
          />
        </el-form-item>
      </el-col>
      <el-col
        :sm="12"
        :lg="6"
      >
        <el-form-item
          :label="$t('profile.newPasswordForm.newPasswordLabel')"
          prop="new_password"
        >
          <el-input
            v-model="form.new_password"
            show-password
            type="password"
            name="new_password"
            :placeholder="$t('profile.newPasswordForm.newPasswordPlaceholder')"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <hr class="newPasswordForm__separator">

    <el-row class="newPasswordForm__continueBlock">
      <el-col :sm="20">
        <p>
          {{ $t('profile.newPasswordForm.continue') }}
        </p>
      </el-col>
      <el-col
        :sm="4"
        class="newPasswordForm__save-container"
      >
        <el-button
          class="newPasswordForm__save"
          type="primary"
          native-type="submit"
          :disabled="!form.password || !form.new_password"
          :loading="loading"
        >{{ $t('profile.newPasswordForm.saveButton') }}</el-button>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  name: "NewPasswordForm",
  data: () => ({
    form: {
      password: null,
      new_password: null
    },
    loading: false
  }),
  computed: {
    rules() {
      return {
        password: { required: true, type: 'string', validator: this.$helpers.passwordValidator },
        new_password: { required: true, type: 'string', validator: this.$helpers.newPasswordValidator }
      }
    }
  },
  methods: {
    async onSubmit() {
      try {
        this.loading = true
        const validation = await this.$refs["newPasswordForm"].validate()

        if (validation) {
          await this.$store.dispatch("customer/resetPassword", this.form)


          this.$notify({
            type: 'success',
            title: 'Profil',
            message: this.$t('profile.newPasswordForm.saved')
          })
        }
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
$c: '.newPasswordForm';

#{$c} {
  padding: 0 24px;
  margin-bottom: 24px;

  &__separator {
    border: 1px solid $--border-color-light;
  }

  &__save-container {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    margin: 15px 0px;
  }

  &__continueBlock p {
    color: $--color-info;
  }
}
</style>